import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PdfViewerComponent } from './pdf-viewer.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PdfViewerComponent],
  exports: [PdfViewerComponent],
})
export class RtUIPdfViewerModule {}

export * from './pdf-viewer.component';
